import { ModulePackFE_OrganizationPermissionModule } from './_entity/organization-permission/index.js';
export const ModulePackFE_OrganizationPermissions = [...ModulePackFE_OrganizationPermissionModule];
//# sourceMappingURL=module-pack.js.map